const preloaded = new Set<string>()

/** Preloads a remote resource like stylesheet, script, blob, etc. */
export const preload = (url: string, type: string, as: string = "fetch") => {
  if (preloaded.has(url)) return

  const link = document.createElement("link")
  /*
   * Notes:
   * 1. Chrome sends warnings to console if resources preloaded by `rel=preload` are not used in a few seconds after they are loaded.
   * To workaround this, it is suggested to use `rel=prefetch` instead of `rel=preload`.
   * 2. Safari does not support `rel=prefetch yet`, so we have to fallback to `rel=preload`.
   */
  const rel = link.relList?.supports?.("prefetch") ? "prefetch" : "preload"

  link.rel = rel
  link.href = url
  link.type = type
  link.as = as
  link.crossOrigin = "anonymous"
  link.referrerPolicy = "no-referrer"

  link.addEventListener("load", () => link.remove(), { once: true })
  link.addEventListener("error", () => link.remove(), { once: true })
  link.addEventListener("error", () => preloaded.delete(url), { once: true })

  document.head.appendChild(link)

  preloaded.add(url)

  return new Promise<void>((resolve, reject) => {
    link.addEventListener("load", () => resolve(), { once: true })
    link.addEventListener("error", () => reject(), { once: true })
  })
}
